// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1xvht","footer":"ReportModalFilter_footer__2AOKL"};